<template>
  <router-view></router-view>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: "Product",
    components: {},
    props: {},
    data() {
      return {}
    },
    methods: {},
    mounted() {

    },
    computed: {
      ...mapGetters([]),
      getComponentName() {
        return "Product"
      }
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Product.vue